import {
  post
} from "@/utils/utils";
// 导购相关接口
const redPackageConfig = {
  state: {},
  mutations: {
    OBTAIN_AUTO_ALLOC_RULES() {},
    BULK_OPEN_WORK_CONFIG() {},
    QUERY_ACCOUNT_INFO_PAGELIST() {},
    BULK_OPEN_ACCOUNT_WORK_CONFIG() {},
    REMOVE_BY_IDS() {},
    QUERY_REMAIN_BILLSTAT() {},
    QUERY_AUTO_ALLOC_CONFIG() {},
    MODIFY_AUTO_ALLOC_CONFIG() {},
    QUERY_ACCOUNT_REMAIN_BILL_STAT() {},
    QUERY_SUPPLIER_WORK_PLANLIST() {},
    ADJUSTING_WORKLOAD() {},
    SUPPLIER_WORK_PLAN_QUERYWORK_STAT_BYID() {},
    START_WORK() {},
    QUERY_ALL_SUPPLY() {},
    QUERY_ACCOUNT_WAIT_BILL_STAT(){},
    QUERY_SUPPLIER_BLANCE_WARNING_LIST(){},
    OBTAIND_ATA(){},
    DAILY_AUTO_ALLOC_PLAN_JOB(){}
  },
  actions: {
    dailyAutoAllocPlanJob({
      commit
    }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/work/supplierWorkAllocRecord/dailyAutoAllocPlanJob`,
        name: "DAILY_AUTO_ALLOC_PLAN_JOB",
        params
      });
    },
    obtainAutoAllocRules({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/obtainAutoAllocRules`,
        name: "OBTAIN_AUTO_ALLOC_RULES",
        params
      });
    },
    bulkOperWorkConfig({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/bulkOperWorkConfig`,
        name: "BULK_OPEN_WORK_CONFIG",
        params
      });
    },
    bulkOperAccountWorkConfig({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/bulkOperAccountWorkConfig`,
        name: "BULK_OPEN_ACCOUNT_WORK_CONFIG",
        params
      });
    },
    queryAccountInfoPageList({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/queryAccountInfoPageList`,
        name: "QUERY_ACCOUNT_INFO_PAGELIST",
        params
      });
    },
    removeByIds({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/removeByIds`,
        name: "REMOVE_BY_IDS",
        params
      });
    },
    queryRemainBillStat({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkAllocRecord/queryRemainBillOverview`,
        name: "QUERY_REMAIN_BILLSTAT",
        params
      });
    },
    queryAutoAllocConfig({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/queryAutoAllocConfig`,
        name: "QUERY_AUTO_ALLOC_CONFIG",
        params
      });
    },
    queryAllsupply({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkPlan/queryWorkStatByAllocWorkId`,
        name: "QUERY_ALL_SUPPLY",
        params
      });
    },
    modifyAutoAllocConfig({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkConfig/modifyAutoAllocConfig`,
        name: "MODIFY_AUTO_ALLOC_CONFIG",
        params
      });
    },
    queryAccountRemainBillStat({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkAllocRecord/queryAccountRemainBillStat`,
        name: "QUERY_ACCOUNT_REMAIN_BILL_STAT",
        params
      });
    },
    querySupplierWorkPlanList({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkPlan/querySupplierWorkPlanList`,
        name: "QUERY_SUPPLIER_WORK_PLANLIST",
        params
      });
    },
    adjustingWorkload({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkPlan/adjustingWorkload`,
        name: "ADJUSTING_WORKLOAD",
        params
      });
    },
    supplierWorkPlanqueryWorkStatById({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkPlan/queryWorkStatById`,
        name: "SUPPLIER_WORK_PLAN_QUERYWORK_STAT_BYID",
        params
      });
    },

    startWork({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkPlan/startWork`,
        name: "START_WORK",
        params
      });
    },

    querySupplierBalanceWarningList({
      commit
    }, params) {
      return post({
        commit,
        url: `/supplierBasicInfo/querySupplierBalanceWarningList`,
        name: "QUERY_SUPPLIER_BLANCE_WARNING_LIST",
        params
      });


      
    },

    obtainData({
      commit
    }, params) {
      return post({
        commit,
        url: `/micro/template/sysSqlTemplateInfo/obtainData`,
        name: "OBTAIND_ATA",
        params
      });
      
    },


    queryAccountWaitBillStat({
      commit
    }, params) {
      return post({
        commit,
        url: `/work/supplierWorkAllocRecord/queryAccountWaitBillStat`,
        name: "QUERY_ACCOUNT_WAIT_BILL_STAT",
        params
      });
    }



    
  }
};

export default redPackageConfig;